import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { EclassDto } from '../models/eclass-dto';

export const ECLASSES_REQUEST = 'ECLASS_REQUEST';
export const ECLASSES_RECEIVED = 'ECLASS_RECEIVED';

const eclassesReceived = (eclasses: EclassDto[]) => {
    return { type: ECLASSES_RECEIVED, eclasses };
};

export const fetchEclasses = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: ECLASSES_REQUEST });

        const response = await api.eclass.cget();

        if (response.success) {
            dispatch(eclassesReceived(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
